import React from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import { useIntl } from "react-intl";

export function TextCell(props) {
  let formattedContent;

  try {
    const intl = useIntl();
    if (typeof props.text === "string") {
      formattedContent = intl.formatMessage({
        id: props.text,
        defaultMessage: props.text,
        description: "",
      });
      formattedContent = parse(formattedContent);
    } else {
      formattedContent = props.text;
    }
  } catch (error) {
    formattedContent = parse(props.text);
  }

  return (
    <td className={props.className} colspan={props.colspan}>
      <div className={`dataTable_row_fixed_contents`}>
        <p>{formattedContent}</p>
      </div>
    </td>
  );
}

TextCell.propTypes = {
  /**
   * Text to be displayed on the cell
   */
  text: PropTypes.string,
  /**
   * className to be set on the cell
   */
  className: PropTypes.string,
};
